/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
// we need to use tabindex on popup ^^ so it could be interactable right away
// when it's appears
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ScreenOverlay from '../../components/body/ScreenOverlay';
import { getFocusableElementsList, handleTabKeyPress } from './utils';

const Popup = ({ header, message, buttons, cssClass }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        const modalElement = modalRef.current;
        // apply focus to popup in order to operate popup buttons
        modalElement.focus();

        const [firstElement, lastElement] = getFocusableElementsList(modalElement);

        modalElement.addEventListener('keydown', handleTabKeyPress(firstElement, lastElement));
        return () => {
            modalElement.removeEventListener(
                'keydown',
                handleTabKeyPress(firstElement, lastElement),
            );
        };
    }, []);

    return (
        <ScreenOverlay>
            <div className={classNames('dashboard-popup', 'dashboard-' + cssClass)} ref={modalRef} tabIndex={0}>
                <div className='dashboard-popup-header'>{header}</div>

                <div className='dashboard-popup-content'>
                    <div className='dashboard-popup-text'>{message}</div>

                    {buttons.length > 0 && <div className='dashboard-popup-buttons'>{buttons}</div>}
                </div>
            </div>
        </ScreenOverlay>
    );
};

Popup.propTypes = {
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttons: PropTypes.arrayOf(PropTypes.element),
    cssClass: PropTypes.string,
};

Popup.defaultProps = {
    header: 'dashboard-',
    message: 'dashboard-',
    buttons: [],
    cssClass: 'dashboard-',
};

export default Popup;
